class Node {
    constructor(id, data = {}) {
        this.id = id;
        this.data = data;
    }
}

export default Node;



// WEBPACK FOOTER //
// ./src/service/graph/Node.js